module.exports = __webpack_public_path__ + "img/logo_pdo.5f19f28e.png";